export default {"src":"/login-app/[GIT_HASH]/_next/static/media/gitlab.161e57fe.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};